import React from "react";
import { motion } from "framer-motion";

interface LoadingAnimationProps {
  title?: string;
  className?: string;
  textClassName?: string;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  title,
  className,
  textClassName,
}) => {
  const dotVariants = {
    initial: {
      y: "0%",
    },
    animate: {
      y: ["0%", "-70%", "0%"],
    },
  };

  const dotTransition = (delay: number) => ({
    duration: 0.7,
    repeat: Infinity,
    ease: "easeInOut",
    delay,
  });

  return (
    <motion.div
      className={`flex flex-col items-center justify-center h-full w-full p-4 bg-white rounded-lg  ${
        className || ""
      }`}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <motion.div
        className="flex space-x-2 mb-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className="w-3 h-3 bg-sky-600 rounded-full"
            variants={dotVariants}
            initial="initial"
            animate="animate"
            transition={dotTransition(i * 0.15)}
          />
        ))}
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 100, damping: 15, delay: 0.3 }}
      >
        <p
          className={`mt-2 text-lg font-medium text-slate-600 tracking-wide ${
            textClassName || ""
          }`}
        >
          {title || "Loading, please wait..."}
        </p>
      </motion.div>
    </motion.div>
  );
};

export default LoadingAnimation;
